import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const { user } = useAuth();
  const [labels, setLabels] = useState(null);
  const [permisMeta, setPermisMeta] = useState({});
  const [roles, setRoles] = useState([]);
  const [roleLabels, setRoleLabels] = useState({});
  const [sites, setSites] = useState([]);
  const [entreprises, setEntreprises] = useState([]);
  const [zones, setZones] = useState([]);
  const [selectedSite, setSelectedSite] = useState("all");
  const [theme, setTheme] = useState(() => localStorage.getItem("pc_theme") || "light");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("pc_theme", theme);
  }, [theme]);

  const loadRef = useCallback(async () => {
    try {
      const [b, s, e, z] = await Promise.all([
        api.get("/bootstrap"), api.get("/sites"), api.get("/entreprises"), api.get("/zones"),
      ]);
      setLabels(b.data.labels);
      setPermisMeta(b.data.permisMeta);
      setRoles(b.data.roles);
      setRoleLabels(b.data.roleLabels || {});
      setSites(s.data);
      setEntreprises(e.data);
      setZones(z.data);
      setLoaded(true);
    } catch (err) {
      // 401 handled by the axios interceptor (redirect to login); ignore here to avoid overlay.
    }
  }, []);

  useEffect(() => {
    if (user && user.id) loadRef();
  }, [user, loadRef]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  const zoneName = (id) => zones.find((z) => z.id === id)?.nom || id;
  const entName = (id) => entreprises.find((e) => e.id === id)?.nom || id;
  const siteName = (id) => sites.find((s) => s.id === id)?.nom || id;

  return (
    <AppCtx.Provider value={{
      labels, permisMeta, roles, roleLabels, sites, entreprises, zones, setZones, setEntreprises, setSites,
      selectedSite, setSelectedSite, theme, toggleTheme, loaded, loadRef,
      zoneName, entName, siteName,
    }}>
      {children}
    </AppCtx.Provider>
  );
}
